<template>
  <div>
    <Head :title="`${form.name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/skus">SKU</Link>
        <span class="text-orange-400 font-medium">/</span>
        {{ form.sku }}/<Link class="text-orange-400 hover:text-orange-600" href="/sku-items">Items</Link>
        <span class="text-orange-400 font-medium">/</span>{{ form.name }}
      </h1>
    </div>
    <div class="flex justify-start mb-8 max-w-3xl">
      <Link class="btn-orange" :href="`/sku-items/${form.sku_id}/items/create`">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Sku Item</span>
      </Link>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-4/4" label="Name" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Update SKU Item</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    item: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.item.name,
        sku: this.item.sku,
        sku_id: this.item.sku_id,
        description: this.item.description,
        unit_of_measure: this.item.unit_of_measure,
        category: this.item.category,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/sku-items/${this.item.sku_id}/items/${this.item.id}`)
    },
  },
}
</script>
